<template>
    <div class="dashboard-page">
        <div class="header">
            <span class="greeting-msg">
                {{ sayHiText }}
            </span>
            <span class="datetime-msg">
                {{ timeText }} : {{ time }}
            </span>
            <employee-summary-box :employeeData="employeeData" />
        </div>

        <div class="dashboard-container">
            <div class="graph-employee-late-absent">
                <total-employee-graph />
            </div>
            <div class="graph-average-time">
                <average-time-check-in-graph />
            </div>
            <div class="inquiry-approval">
                <inquiry-quick-review @changeStatus="loadDataOnsite"/>
            </div>
            <div class="employee-onsite-today">
                <onsite-today-table ref="onsite" />
            </div>
        </div>
    </div>
</template>

<script>
import TotalEmployeeGraph from '@/components/dashboard/TotalEmployeeGraph'
import EmployeeSummaryBox from '@/components/dashboard/EmployeeSummaryBox'
import AverageTimeCheckInGraph from '@/components/dashboard/AverageTimeCheckInGraph'
import InquiryQuickReview from '@/components/dashboard/InquiryQuickReview'
import OnsiteTodayTable from '@/components/dashboard/OnsiteTodayTable'

export default {
    name: 'Dashboard',

    components: {
        EmployeeSummaryBox,
        TotalEmployeeGraph,
        AverageTimeCheckInGraph,
        InquiryQuickReview,
        OnsiteTodayTable
    },

    data () {
        return {
            employeeData: {
                total: 0,
                normal: 0,
                late: 0,
                absent: 0,
                onsite: 0,
                leave: 0
            },
            sayHiText: null,
            datetime: new Date(),
            branchId: null,
            intervalTime: null
        }
    },

    computed: {
        username () {
            return localStorage.getItem('username')
        },
        time () {
            return `${
                this.datetime.getHours().toString().padStart(2, '0')
            } : ${
                this.datetime.getMinutes().toString().padStart(2, '0')
            }`
        },

        timeText () {
            return this.$util.datetoDateString(this.datetime, this.$vuetify.lang.current)
        }
    },

    methods: {
        initDashboardData () {
            this.datetime = new Date()
            const curHr = this.datetime.getHours()

            if (curHr < 12) {
                this.sayHiText = `${this.$vuetify.lang.t('$vuetify.dashboard.goodMorning')}, `.toUpperCase()
            } else if (curHr < 18) {
                this.sayHiText = `${this.$vuetify.lang.t('$vuetify.dashboard.goodAfternoon')}, `.toUpperCase()
            } else {
                this.sayHiText = `${this.$vuetify.lang.t('$vuetify.dashboard.goodEvening')}, `.toUpperCase()
            }
        },

        timeInterval () {
            this.intervalTime = setInterval(this.initDashboardData, 200)
        },

        async getEmployeeData (branchId) {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.get(`dashboard/getEmployeeDataForDashBoard?branch=${branchId}`)
            if (res && res.data && res.data.status) {
                this.employeeData = res.data.data
                this.$store.dispatch('setLoading', false)
            }
        },

        async getBranch () {
            this.branchId = localStorage.getItem('currentBranchId')
            if (this.branchId) {
                await this.getEmployeeData(this.branchId)
            }
        },

        loadDataOnsite () {
            this.$refs.onsite.loadData()
        }
    },

    async mounted () {
        this.initDashboardData()
        this.timeInterval()
        await this.getBranch()
    },

    beforeDestroy () {
        clearInterval(this.intervalTime)
    },

    watch: {
        '$store.state.currentBranchId': async function (newValue) {
            if (newValue) {
                this.branchId = newValue
                await this.getEmployeeData(newValue)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.dashboard-page {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .header {
        .greeting-msg {
            font-size: 32px;
        }

        .datetime-msg {
            font-size: 18px;
        }
    }
    .say-hi {
        font-size: 1.25rem;
        font-weight: 500;
    }
    .dashboard-container {
        display: grid;
        margin-bottom: 2rem;
        grid-auto-rows: 1fr;
        grid-gap: 24px;
        grid-template-columns: calc(33% - 12px) calc(34% - 24px) calc(33% - 12px);
        color: #444;
    }
    .card {
        background-color: #444;
        color: #fff;
        border-radius: 5px;
        padding: 20px;
        font-size: 150%;
    }

    .employee-onsite-today {
        grid-column: 1 / span 2;
        grid-row: 2 / 2;
    }
    .inquiry-approval {
        grid-column: 3 ;
        grid-row: 1 / span 2;
    }
    .graph-employee-late-absent {
        grid-column: 1;
        grid-row: 1 / 1;
    }
    .graph-average-time {
        grid-column: 2;
        grid-row: 1 / 1;
    }
}
</style>
